import React, { useContext, useState, useMemo } from "react";
import { BsDownload, BsFillEyeFill } from "react-icons/bs";
import { FaArchive, FaTrash } from "react-icons/fa";
import Id from "../../../../components/Formatters/Id";
import ButtonImagePermission from "../../../../components/UI/Button/ButtonImagePermission";
import { AuthContext, funcionalidades } from "../../../../context/AuthContext";
import { Data, formatarData } from "../../../../components/Formatters/DateTime";
import ButtonImage from "../../../../components/UI/Button/ButtonImage";
import useDocumentoPS from "./useDocumentoPS";

const useColumns = ({ verificaPs, verificaPsExcluir, setDocParams, origem }) => {
  const { isAllowed } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);
  const [textoCancelamento, setTextoCancelamento] = useState("");
  const [textoOsSpf, setTextoOsSpf] = useState("");
  const [tipoTexto, setTipoTexto] = useState("");

  let texto = "";

  const permissao = useMemo(() => {
    if (isAllowed(funcionalidades.parteServico.gerencial)) {
      return "Gerencial";
    } else if (isAllowed(funcionalidades.parteServico.adm)) {
      return "Admin";
    } else {
      return "Auditor";
    }
  }, [isAllowed]);

  const exibirDocumento = (sqParteServico) => {
    setDocParams({ sqParteServico });
  };

  const montarTexto = (row) => {
    texto =
      `<p>` +
      `<b> Parte Serviço Nº:</b> ${row.sqParteServico} / ${
        row.tmInclusao ? new Date(row.tmInclusao).getFullYear() : ""
      } <br />` +
      `<b> Status: </b> ${row.txStParteServico === "C" ? "Cancelada" : "Encerrada"} <br />` +
      `<b> Motivo: </b> ${row.txJustificativaCancelamento ?? ""} <br />` +
      `<b> Data: </b> ${row.dataCancelamento ? formatarData(row.dataCancelamento, "dd/MM/yyyy HH:mm") : ""} <br />` +
      `<b> Usuário: </b> ${row.nmPessoaCancelamento} - ${row.matAuditorCancelamento} <br />` +
      `</p>`;
    setTextoCancelamento(texto);
    setTipoTexto("A");
  };

  const montarTextoOsSpf = (row) => {
    texto =
      `<p>` +
      ` Gerada a <b> ${row.txStParteServico === "V" ? "SPF" : "OS"} ${
        row.txStParteServico === "V" ? row.sqAberturaProcesso : row.sqOrdemServico
      } </b> em  <b>${
        row.txStParteServico === "V"
          ? formatarData(row.dataInclusaoSpf, "dd/MM/yyyy HH:mm")
          : formatarData(row.dataInclusaoOs, "dd/MM/yyyy HH:mm")
      } </b>` +
      `</p>`;
    setTextoOsSpf(texto);
    setTipoTexto("B");
  };

  const { buscaDocumento } = useDocumentoPS();

  const columns = [
    {
      name: "N° Parte de Serviço",
      selector: (row) => row.sqParteServico,
      maxWidth: "10%",
      center: true,
      sortable: true,
    },

    {
      name: "Tipo",
      selector: (row) => row.tipo,
      maxWidth: "15%",
      center: true,
      sortable: true,
    },
    {
      name: "Setor Destino",
      selector: (row) => row.txSgOrgao,
      maxWidth: "10%",
      center: true,
      sortable: true,
    },
    {
      name: "IE",
      selector: (row) => <Id value={row.nuIE ?? row.nuCNPJ ?? row.nuCPF} />,
      center: true,
      maxWidth: "10%",
    },
    {
      name: "Razão Social",
      selector: (row) => row.txNmFormal,
      sortable: true,
      maxWidth: "20%",
    },
    {
      name: "Data Inclusão",
      selector: (row) => <Data value={row.tmInclusao} />,
      maxWidth: "10%",
      center: true,
      sortable: true,
    },
    {
      name: "Situação",
      selector: (row) => {
        switch (row.txStParteServico) {
          case "A":
            return "Aberta";
          case "C":
            return "Cancelada";
          case "E":
            return "Encerrada";
          case "V":
            return "Vinculada a Procedimento Fiscal";
          case "G":
            return "Gerada OS";
          case "S":
            return "Salva";
          default:
            return "-";
        }
      },
      maxWidth: "17%",
      center: true,
      sortable: true,
    },
    {
      name: "Ações",
      selector: "",
      maxWidth: "8%",
      center: true,
      cell: (row) => (
        <>
          {row.existeArquivo === "S" && (
            <ButtonImage
              variant="btn-link"
              className="btn-lg pa-0 p-0 mx-1"
              buttonImage={<BsDownload size="15" style={{ color: "#E65729" }} />}
              tooltipImage={row.txStParteServico === "C" ? "Documento Cancelado" : "Visualizar Documento"}
              onClick={() => {
                buscaDocumento(row.sqParteServico);
              }}
            />
          )}

          {row.existeArquivo === "N" && (
            <ButtonImage
              className="btn-lg text-success pa-0 p-0"
              buttonImage={<BsDownload size="16" color="#e37023" />}
              tooltipImage={row.txStParteServico === "C" ? "Documento Cancelado" : "Visualizar Documento"}
              onClick={() => exibirDocumento(row.sqParteServico)}
              disabled={row.txStParteServico === "C"}
            />
          )}

          {/* REGRAS ENCERRAR PARTE DE SERVICO */}
          {(row.txStParteServico === "S" || row.txStParteServico === "A") &&
            permissao !== "Auditor" &&
            origem !== "dossie" && (
              <ButtonImagePermission
                permission={funcionalidades.parteServico.encerrar}
                className="btn pa-0 p-0 px-1 btnOrange"
                onClick={() => {
                  verificaPs(row.sqParteServico);
                }}
                buttonImage={<FaArchive />}
                tooltipImage="Encerrar"
              />
            )}

          {row.txStParteServico !== "S" &&
            row.txStParteServico !== "A" &&
            permissao !== "Auditor" &&
            origem !== "dossie" && (
              <ButtonImagePermission
                permission={funcionalidades.parteServico.permissaonegada}
                className="btn pa-0 p-0 px-1"
                onClick={() => {}}
                buttonImage={<FaArchive />}
                tooltipImage="Encerrar"
              />
            )}
          {/* FIM REGRAS ENCERRAR */}

          {row.txStParteServico === "S" && (
            <ButtonImagePermission
              permission={funcionalidades.parteServico.deletar}
              className="btn-sm text-danger pa-0 p-0 px-1"
              onClick={() => {
                verificaPsExcluir(row.sqParteServico);
              }}
              buttonImage={<FaTrash />}
              tooltipImage="Cancelar"
            />
          )}
          {row.txStParteServico !== "S" && origem !== "dossie" && (
            <ButtonImagePermission
              permission={funcionalidades.parteServico.permissaonegada}
              className="btn-sm pa-0 p-0 px-1"
              onClick={() => {}}
              buttonImage={<FaTrash />}
              tooltipImage="Cancelar"
            />
          )}

          {(row.txStParteServico === "E" || row.txStParteServico === "C") && (
            <ButtonImage
              className="btn-sm btnOrange pa-0 p-0 px-1"
              buttonImage={<BsFillEyeFill />}
              tooltipImage={`Ver motivo do ${row.txStParteServico === "E" ? "Encerramento" : "Cancelamento"}`}
              onClick={() => {
                setShowModal(true);
                montarTexto(row);
              }}
            />
          )}

          {(row.txStParteServico === "V" || row.txStParteServico === "G") && (
            <ButtonImage
              className="btn-sm btnOrange pa-0 p-0 px-1"
              buttonImage={<BsFillEyeFill />}
              tooltipImage={`Ver número da  ${row.txStParteServico === "V" ? "SPF" : "OS"}`}
              onClick={() => {
                setShowModal(true);
                montarTextoOsSpf(row);
              }}
            />
          )}
        </>
      ),
    },
  ];

  return { columns, showModal, setShowModal, textoCancelamento, textoOsSpf, tipoTexto };
};

export default useColumns;
